import { SignageAdapterApi } from "@vacancorp/signage.adapter.api.vacanservice.com";
import { MutationTree } from "vuex";

import types from "@/store/types";
import { PlaceState, GenderData, CellData,CellDataData } from "@/store/place/state";

export const mutations: MutationTree<PlaceState> = {
    [types.place.mutations.SET_PLACE_ID_HASH_LIST]: (state: PlaceState, placeIdHashList: string[]) => {
        const list: SignageAdapterApi.ResponseGetPlace[] = Object.assign([], placeIdHashList);
        for (const floors in state.floorPlan) {
            // loop floor cells, cell1 or cell2
            for (const floorCell in state.floorPlan[floors].cell) {
                // set data for each cells
                const cells = state.floorPlan[floors].cell[floorCell];
                for (const cellKeys in cells.keys) {
                    const genderKeys = cells.keys[cellKeys];
                    if (genderKeys !== "") {
                        // assign data
                        state.floorPlan[floors].cell[floorCell].data[genderKeys as keyof CellDataData] = {placeIdHash:list.shift()};
                    }
                }
            }
        }
        state.placeIdHashList = placeIdHashList;
    },
    [types.place.mutations.SET_DISPLAY_VACANCY_LIST]: (
        state: PlaceState,
        displayVacancyList: SignageAdapterApi.ResponseGetDisplayVacancy[],
    ) => {
        state.displayVacancyList = displayVacancyList;
    },
    [types.place.mutations.SET_AREA_GENDER]: (
        state: PlaceState,
        areaGenderList: [],
    ) => {
        state.areaGenderList = areaGenderList;
    },  
    [types.place.mutations.SET_FETCHING_PLACE_TIMER]: (
        state: PlaceState,
        fetchingPlaceTimer: NodeJS.Timer | undefined,
    ) => {
        state.fetchingPlaceTimer = fetchingPlaceTimer;
    },
    [types.place.mutations.SET_FETCHING_VACANCY_TIMER]: (
        state: PlaceState,
        fetchingVacancyTimer: NodeJS.Timer | undefined,
    ) => {
        state.fetchingVacancyTimer = fetchingVacancyTimer;
    },
    [types.place.mutations.SET_FLOOR_PLAN]: (state: PlaceState, placeList: SignageAdapterApi.ResponseGetPlace[]) => {
        placeList.sort((a: SignageAdapterApi.ResponseGetPlace, b: SignageAdapterApi.ResponseGetPlace) => {
            return state.placeIdHashList.indexOf(a.placeIdHash) - state.placeIdHashList.indexOf(b.placeIdHash);
        });
        //console.log("types.place.mutations.SET_FLOOR_PLAN]");
        const list: SignageAdapterApi.ResponseGetPlace[] = Object.assign([], placeList);
        for (const floors in state.floorPlan) {
            // loop floor cells, cell1 or cell2
            for (const floorCell in state.floorPlan[floors].cell) {
                // set data for each cells
                const cells = state.floorPlan[floors].cell[floorCell];
                for (const cellKeys in cells.keys) {
                    const genderKeys = cells.keys[cellKeys];
                    if (genderKeys !== "") {
                        // assign data
                        //state.floorPlan[floors].cell[floorCell].data[genderKeys as keyof GenderData] = list.shift();
                    }
                }
            }
        }
    },
};
